import styled from 'styled-components';
import { em } from 'polished';

const DetailWrapper = styled.div`
  margin-bottom: ${em(18)};
  white-space: pre-wrap;
`;

export default DetailWrapper;



// WEBPACK FOOTER //
// ./src/modules/common/DetailWrapper.js